<template>
  <div class="personal-info">
    <span> اطلاعات شخصی </span>
    <AccountField v-model="data.firstName" label="نام" type="persian" />
    <AccountField v-model="data.lastName" label="نام خانوادگی" type="persian" />
    <div class="ac-input">
      <!-- <label class="bd" for=""> -->
      <date-picker
        placeholder=" تاریخ تولد "
        v-model="data.birthDay"
        :format="$dateFormat['en']"
        :display-format="$dateFormat['fa']"
        :clearable="!state.userInfo.authorized"
        :class="'date-fa'"
        class="date"
      />
      <!-- </label> -->
    </div>
    <AccountField
      v-model="data.nationalCode"
      label="کد ملی"
      type="number"
      :maxLength="countryName == 'Iran' ? 10 : 20"
      ltr
    />
    <AccountField v-model="data.state" label="استان" type="persian" />
    <AccountField v-model="data.city" label="شهر" type="persian" />
  </div>
</template>

<script>
import AccountField from "./AccountField.vue";
export default {
  components: { AccountField },
  props: ["data", "countryName"],
};
</script>

<style lang="scss" scoped>
.ac-input {
  border-radius: 4px;
  // overflow: hidden;
  .bd {
    input {
      width: 100%;
    }
  }
  display: flex;
  flex-direction: column;
  row-gap: 3px;
  width: 100%;
  .active-span {
    color: var(--primary-color);
    transform: translateY(-25px);
  }
  label {
    display: flex;
    flex-direction: row;
    background: var(--light-grey);
    padding: 8px 12px;
    border-radius: 4px;
    position: relative;
    input {
      background: transparent;
      width: 80%;
      z-index: 2;
    }
    span {
      transform: translateY(0px);
      font-weight: 400;
      font-size: clamp(12px, 2vw, 14px);
      transition: 500ms;
      position: absolute;
    }
  }
}
span {
  font-weight: 400;
  font-size: clamp(14px, 2vw, 18px);
}
.personal-info {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  padding: 24px;
  background: var(--box);
  border-radius: 12px;
  width: 100%;
  input {
    width: 100% !important;
  }
}
</style>
